import React from 'react'
import { Link } from 'gatsby'

import { Download } from '~/icons/Download'
import { ArrowRight } from '~/icons/ArrowRight'
import { Linkedin } from '~/icons/Linkedin'
import { cn } from '~/utils/classnames'

const LinkIcon = ({
  text,
  link,
  small,
  className,
  color,
  external,
  noFollow,
  icon,
  mailto,
  state,
  contentType = false,
}) => {
  let button, IconComponent

  color = color ? color : 'purple'

  switch (icon) {
    case 'linkedin':
      IconComponent = Linkedin
      break
    case 'download':
      IconComponent = Download
      break
    default:
      IconComponent = ArrowRight
  }

  if (link) {
    if (external) {
      button = (
        <ExternalLink
          text={text}
          small={small}
          className={className}
          color={color}
          link={link}
          noFollow={noFollow}
          icon={IconComponent}
          mailto={mailto}
        />
      )
    } else {
      button = (
        <InternalLink
          text={text}
          small={small}
          className={className}
          color={color}
          link={link}
          icon={IconComponent}
          state={state}
          contentType={contentType}
        />
      )
    }
  } else {
    button = (
      <NoLink
        text={text}
        small={small}
        className={className}
        color={color}
        icon={IconComponent}
      />
    )
  }

  return <>{button}</>
}

const InnerContent = ({ text, small, className, color, icon }) => {
  let InnerIconComponent = icon
  return (
    <>
      <span className="link-icon__icon link-icon__icon--left">
        <InnerIconComponent
          className={cn(
            small
              ? `icon-${color} pt-[1px] pl-[1px]`
              : 'icon-white pt-[1px] pl-[1px]',
          )}
          width={icon === 'arrow-right' ? 12 : 16}
          height={icon === 'arrow-right' ? 12 : 16}
        />
      </span>
      <span
        className="link-icon__txt"
        dangerouslySetInnerHTML={{ __html: text }}
      ></span>
      <span className="link-icon__icon link-icon__icon--right">
        <InnerIconComponent
          className={
            small
              ? `icon-${color} pt-[1px] pl-[1px]`
              : 'icon-white pt-[1px] pl-[1px]'
          }
          width={icon === 'arrow-right' ? 12 : 16}
          height={icon === 'arrow-right' ? 12 : 16}
        />
      </span>
    </>
  )
}

const InternalLink = ({
  text,
  link,
  small,
  className,
  color,
  icon,
  state,
  contentType,
}) => {
  return (
    <>
      {contentType === 'ContentfulSimulator' ||
      contentType === 'ContentfulContact' ? (
        <a
          href={link}
          className={`link-icon text-${color} ${small ? `link-icon--small` : ''} ${className ? className : ''}`}
          aria-label="Open"
        >
          <InnerContent
            text={text}
            small={small}
            className={className}
            color={color}
            icon={icon}
          />
        </a>
      ) : (
        <Link
          to={link}
          state={state}
          className={`link-icon text-${color} ${small ? `link-icon--small` : ''} ${className ? className : ''}`}
        >
          <InnerContent
            text={text}
            small={small}
            className={className}
            color={color}
            icon={icon}
          />
        </Link>
      )}
    </>
  )
}

const ExternalLink = ({
  text,
  link,
  small,
  className,
  color,
  noFollow,
  icon,
  mailto,
}) => {
  let rel
  let target = '_blank'

  if (mailto) {
    link = `mailto:${link}`
    target = ''
  }

  if (noFollow) {
    rel = 'noopener noreferrer nofollow'
  } else {
    rel = 'noopener noreferrer'
  }

  return (
    <a
      href={link}
      target={target}
      rel={rel}
      aria-label={text}
      className={`link-icon text-${color} ${small ? `link-icon--small link-icon--small-${color}` : ''} ${className ? className : ''}`}
    >
      <InnerContent
        text={text}
        small={small}
        className={className}
        color={color}
        icon={icon}
      />
    </a>
  )
}

const NoLink = ({ text, small, className, color, icon }) => {
  return (
    <span
      className={`link-icon text-${color} ${small ? 'link-icon--small' : ''} ${className ? className : ''}`}
    >
      <InnerContent
        text={text}
        small={small}
        className={className}
        color={color}
        icon={icon}
      />
    </span>
  )
}

export default LinkIcon
